import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { AddIcon } from '@diligentcorp/atlas-react-icons';
import { paths } from '@issuemanager/apps/client/paths';
import { useTranslation } from 'react-i18next';

export function IssueTemplatesGridToolbarAddIssueTemplate() {
  const { t } = useTranslation(['settings']);

  return (
    <Link to={paths.issueTemplates.add}>
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        data-testid='add-issue-template-button'
      >
        {t('settings:issueTemplates.add')}
      </Button>
    </Link>
  );
}
